import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiObjectData } from '../models/api-object-data';
import { School } from '../models/school';
import { BaseService } from './base.service';


@Injectable({
  providedIn: 'root'
})
export class SchoolService {

  controller = 'school';

  constructor(private base: BaseService) {
  }

  get(id): Observable<ApiObjectData> {
    return this.base.get(id, this.controller);
  }

  gets(): Observable<ApiObjectData> {
    return this.base.gets(this.controller);
  }

  getAllTeachers(): Observable<ApiObjectData> {
    return this.base.gets(this.controller + '/getTeachers/' + this.base.schoolId);
  }

  save(obj: School) {
    return this.base.save(this.controller, obj);
  }

  delete(id: number) {
    return this.base.delete(this.controller, id);
  }

}
